import { render, staticRenderFns } from "./PercentageBars.vue?vue&type=template&id=a38e9320&"
import script from "./PercentageBars.vue?vue&type=script&lang=js&"
export * from "./PercentageBars.vue?vue&type=script&lang=js&"
import style0 from "./PercentageBars.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PercentageBars.vue"
export default component.exports